import React from "react";
import SettingsPage from "../components/SettingsPane/SettingsPage";
import { CheckboxFieldSettings } from "../SettingsScreen";
import { itx } from "../translationItx/itx";


export default function SettingPageRoomplans(props: {
  handler: string;
  dropDownColor: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { dropDownColor, setRefresh, refresh } = props;

  function BackgroundDefaultElement(props: {}) {
    function ValueRow(props: { name: string; value: string; minMax: { min: number; max: number; step: string } }) {
      const { name, value, minMax } = props;
      return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "200px" }}>
          <div style={{ paddingRight: "5px", width: "75%" }}>{name}: </div>
          <div
            style={{ color: "grey", whiteSpace: "nowrap", fontSize: "10px", paddingRight: "10px" }}
          >{`(${minMax.min}-${minMax.max})`}</div>
          <div style={{ width: "25%" }}>
            <input
              style={{ borderColor: "var(--border-color)", width: "50px" }}
              key={name + "_texField_input"} // no itx
              type="numeric"
              min={minMax.min}
              max={minMax.max}
              step={minMax.step}
              className="input"
              name={name}
              id={name}
              onBlur={(ev) => {
                const number = parseFloat(ev.target.value);
                if (number >= minMax.min && number <= minMax.max) {
                  (state.settings.defaultBackgroundPictureElements as any)[value] = number;
                } else {
                  ev.target.value = (state.settings.defaultBackgroundPictureElements as any)[value];
                }
                if (setRefresh && refresh) {
                  setRefresh(refresh + 1);
                }
              }}
              defaultValue={(state.settings.defaultBackgroundPictureElements as any)[value]}
              placeholder={(state.settings.defaultBackgroundPictureElements as any)[value]}
            ></input>
          </div>
        </div>
      );
    }

    const elms = [
      { name: "Scale", value: "scale", minMax: { min: 0.5, max: 5, step: "0.01" } }, // no itx
      { name: "Fade", value: "fade", minMax: { min: 0, max: 80, step: "1" } }, // no itx
    ];
    const elmsRows = new Array<any>();
    elms.forEach((elm) => {
      elmsRows.push(<ValueRow name={itx(`SettingsScreen.${elm.name}`)} value={elm.value} minMax={elm.minMax} />);
    });
    return <div style={{ display: "flex", flexDirection: "column" }}>{elmsRows}</div>;
  }

  return (
    <SettingsPage
      handler={props.handler}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {!state.projectMetadata.isC1Project && <>
        <CheckboxFieldSettings
          name="customerView" // no itx
          label={itx("SettingsScreen.customerView", "Kundenansicht")}
          setRefresh={setRefresh}
          refresh={refresh}
        />

        <div className="form-flex" style={{ gap: "20px", alignItems: "flex-start" }}>
          {/* Box 1: Anzeigeelemente */}
          <div className="settings-card">
            <div className="settings-card__header">{itx("SettingsScreen.displaySettings", "Anzeige")}</div>
            <div className="settings-card__body">
              <CheckboxFieldSettings
                name="showSmallHeader" // no itx
                label={itx("SettingsScreen.showSmallHeader", "showSmallHeader")}
                setRefresh={setRefresh}
                refresh={refresh}
              />
              <CheckboxFieldSettings
                name="showIcons" // no itx
                label={itx("SettingsScreen.showIcons", "Symbole anzeigen")}
                setRefresh={setRefresh}
                refresh={refresh}
              />
              <CheckboxFieldSettings
                name="showTags" // no itx
                label={itx("SettingsScreen.showTags", "Tags anzeigen")}
                setRefresh={setRefresh}
                refresh={refresh}
              />
              <CheckboxFieldSettings
                name="showPageBorder" // no itx
                label={itx("SettingsScreen.showBorder", "Seitenrand anzeigen")}
                setRefresh={setRefresh}
                refresh={refresh}
              />
              <CheckboxFieldSettings
                name="showConnectionTexts" // no itx
                label={itx("SettingsScreen.showConnectionsTexts", "Verbindungstexte anstatt Linien anzeigen")}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            </div>
          </div>

          {/* Box 2: Hintergrundbild */}
          <div className="settings-card">
            <div className="settings-card__header">{itx("SettingsScreen.backgroundpicture", "Hintergrundbild")}</div>
            <div className="settings-card__body">
              <BackgroundDefaultElement />
            </div>
          </div>
        </div>
        </>}
      </div>
    </SettingsPage>
  );
}
